/**
 * Convert cents to dollar value
 * @param price Amount in cents
 * @param currency Currency symbol
 */
export const formatPrice = (price: number): string =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(price);
